import localforage from "localforage";

// 🔹 إعداد IndexedDB كمحرك تخزين
const indexedDbStorage = {
  setItem: async (key, value) => {
    await localforage.setItem(key, value);
    return value;
  },
  getItem: async (key) => {
    return await localforage.getItem(key);
  },
  removeItem: async (key) => {
    await localforage.removeItem(key);
  },
};

export default indexedDbStorage;
